// @deprecated (initSlider + featureWrappers.forEach) — slider config moved to:
//   assets/js/components/ui-components/slick-slider.js (preset "legal-hub-explore")
//   Templates updated: legal-hub, healthcare-hub, education-hub (data-lazy-init on .content-section__lh-explore)
//   NOTE: tutorialVideoGallery and scroll tabs below are still active.

document.addEventListener('DOMContentLoaded', () => {
	// Learning hub landing
	function tutorialVideoGallery() {
		const modal = document.getElementById('global-video-modal');
		if (!modal) return; // already inited or missing
		const iframe = modal.querySelector('.sb-video-iframe');
		const titleEl = modal.querySelector('.modal__header-title');

		const videoButtons = document.querySelectorAll('[data-video-src]');

		videoButtons.forEach(btn => {
			btn.addEventListener('click', () => {
				const src = btn.dataset.videoSrc;
				const title = btn.dataset.videoTitle || '';

				titleEl.textContent = title;
				iframe.setAttribute('data-src', src);
				setTimeout(function (){
					iframe.src = src;
				})

				$(modal).modal('show'); // Bootstrap
			});
		});
	}
	tutorialVideoGallery();

	const scrollTabsContainer = document.querySelector('.scroll-tabs');

	function scrollActiveAnchorIntoView(force = false) {
		//console.log('scrollActiveAnchorIntoView');
		if (!scrollTabsContainer) return;

		const activeLink = scrollTabsContainer.querySelector('.sticky-anchors__link.active');
		if (!activeLink) return;

		// Skip if container doesn't scroll horizontally
		if (!force && scrollTabsContainer.scrollWidth <= scrollTabsContainer.clientWidth) {
			return;
		}

		const containerRect = scrollTabsContainer.getBoundingClientRect();
		const activeRect = activeLink.getBoundingClientRect();

		const offsetLeft = activeRect.left - containerRect.left;

		// HERE: Always scroll so the active item sticks to the LEFT
		const targetScrollLeft = scrollTabsContainer.scrollLeft + offsetLeft - 16;
		// 16px for nice small padding – optional

		scrollTabsContainer.scrollTo({
			left: targetScrollLeft,
			behavior: 'smooth',
		});
	}

	requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
	window.addEventListener('load', () => scrollActiveAnchorIntoView(true));

	document.addEventListener('click', (e) => {
		const link = e.target.closest('.sticky-anchors__link');
		if (!link) return;

		requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
		setTimeout(() => scrollActiveAnchorIntoView(true), 50);
		setTimeout(() => scrollActiveAnchorIntoView(true), 150);
	});

	const navList = document.querySelector('#nav-list');

	if (navList) {
		const observer = new MutationObserver(() => {
			requestAnimationFrame(() => scrollActiveAnchorIntoView(true));
		});

		observer.observe(navList, {
			attributes: true,
			subtree: true,
			attributeFilter: ['class'],
		});
	}
});
